import { SET_UI_DIMENSIONS, RESET_WEBRTC_CALL_START } from './types';

export const setUiDimensions = (payload) => ({
  type: SET_UI_DIMENSIONS,
  payload,
});
export const resetWebrtcCallStart = () => ({
  type: RESET_WEBRTC_CALL_START,
});
